import { setupClassicCheckoutListeners } from "../../store/storeListeners";
import $ from "jquery";
import {
	getSelectedPaymentBox,
	isPayoneerGatewaySelected,
	focusOnSelectedGateway
} from "../woocommerce";
import { PAYONEER_STORE_KEY } from "../../store";
import { defaultHooks } from '@wordpress/hooks';
import { select, dispatch } from '@wordpress/data';
import { releaseOnHoldOrder, setOnPaymentDeclinedNonce } from "../../store/actions";
import { PAYMENT_STORE_KEY } from '@woocommerce/block-data';
import { getComponentNameByGatewayId } from '../components';

export const initClassicCheckout = () => {
	console.log('Loading classic checkout integration')
	document.addEventListener(
		'DOMContentLoaded',
		() => {
			setupClassicCheckoutListeners()
			dispatch(PAYONEER_STORE_KEY)
				.setOnPaymentDeclinedNonce(PayoneerData.onPaymentDeclinedNonce);

			const $checkoutForm = $( 'form.checkout' );

			/**
			 * We have to refresh checkout when these fields are changed because Payoneer needs
			 * to have these values asap for Stripe Connect risk detection.
			 */
			$checkoutForm.find(
				'#billing_email,' +
				'#billing_first_name,' +
				'#billing_last_name,' +
				'#shipping_first_name,' +
				'#shipping_last_name' +
				'#billing_state' +
				'#shipping_state' +
				'#billing_address_1' +
				'#shipping_address_1' +
				'#billing_address_2' +
				'#shipping_address_2'
			).on( 'change', () => $( document.body ).trigger( 'update_checkout' ) );

			defaultHooks.addFilter(
				'payoneer.webSdk.onSdkError',
				'payoneer/shortcodeCheckout',
				( isResolved, checkout, component, data ) => {
					wp.data.dispatch(PAYONEER_STORE_KEY).reboot();

					$( document.body ).trigger( 'update_checkout' );
					return isResolved
				}
			);

			wp.hooks.addFilter(
				'payoneer.webSdk.onPaymentDeclined',
				'payoneer/shortcodeCheckout',
				() => {
					wp.data.dispatch(PAYONEER_STORE_KEY).releaseOnHoldOrder(
						{
							longId: select( PAYONEER_STORE_KEY ).getLongId(),
						},
					);
					$( document.body ).trigger( 'update_checkout' );
					return true;
				}
			);

			/**
			 * Cannot use native event listener for events dispatched by jQuery
			 * https://github.com/jquery/jquery/issues/3347
			 */
			$( document.body ).on( 'updated_checkout', () => dispatch( PAYONEER_STORE_KEY ).initPayoneerComponents() );

			$checkoutForm.on('checkout_place_order', () => {
				const payoneerStore = select( PAYONEER_STORE_KEY );
				if ( !isPayoneerGatewaySelected() || payoneerStore.isHostedModeForced() ) {
					return;
				}
				const paymentMethod = getComponentNameByGatewayId(payoneerStore.getActivePaymentMethod());
				const isValid = payoneerStore.getIsValidForComponent(paymentMethod);
				if ( isValid ) {
					return true;
				}

				try {
					focusOnSelectedGateway();
				} catch(error) {
					console.error(error);
				} finally {
					return false;
				}
			} );

			$checkoutForm.on( 'checkout_place_order_success', ( e, result ) => {
				if ( !isPayoneerGatewaySelected() || select( PAYONEER_STORE_KEY ).isHostedModeForced() ) {
					return;
				}
				dispatch( PAYONEER_STORE_KEY ).pay();

				//Override default redirect to hosted payment page
				result.redirect = '#payoneer-redirect';

				/**
				 * Create a timeout that races the SDK's payment handling.
				 * If the handling is not done after 1,5 second, it unblocks
				 * the checkout form and scrolls the users to the payment fields
				 * because probably there is an error displayed there
				 *
				 * This is done since the SDK does not have any validation callback
				 * or Promise we could attach to.
				 */
				setTimeout( () => {
					$checkoutForm.removeClass( 'processing' ).unblock();
					$.scroll_to_notices(
						$( getSelectedPaymentBox() )
					);
				}, 1500 );

				return false;
			} );
		},
		false
	);
}
